<p-table [value]="responses()">
    <ng-template #header>
        <tr>
            <th>Form Name</th>
            <th>Location</th>
            <th>Date Requested</th>
        </tr>
    </ng-template>

    <ng-template #body let-response [appTableRow]="responses()">
        <tr class="cursor-pointer" (click)="rowClick(response)">
            <td>{{response.name}}</td>
            <td>{{response.location}}</td>
            <td>{{response.dateCreated | date}}</td>
        </tr>
    </ng-template>
</p-table>

@if(initialized() && responses().length === 0) {
    <div class="mt-8">You're all caught up!</div>
}



